export default {
  // File actions
  upload: 'Upload',
  download: 'Download',
  delete: 'Delete',
  preview: 'Preview',
  view: 'View',
  editWithAI: 'Edit with AI',

  // File upload
  clickToUpload: 'Click to upload',
  orDragSingle: ' or drag a file here',
  orDragMultiple: ' or drag multiple files here',
  uploading: 'Uploading...',
  uploadSuccess: 'Uploaded {[count]} file(s) successfully',
  uploadFailed: 'Failed to upload: {{files}}',

  // File validation
  fileTooLarge: 'File is too large. Maximum size is {size}MB',
  singleFileOnly: 'Only one file can be uploaded at a time',
  imagesOnly: 'Images only',
  supportedFormats: 'Supported formats: Images, PDF',

  // File info
  fileSizeLabel: 'File size',
  fileType: 'File type',
  filename: 'Filename',
  description: 'Description',
  file: 'File',

  // File size units
  fileSize: {
    zero: '0 Bytes',
    bytes: 'Bytes',
    kb: 'KB',
    mb: 'MB',
    gb: 'GB'
  },

  // Preview
  previewNotAvailable: 'Preview not available for this file type',
  loading: 'Loading...',

  // Order controls
  moveUp: 'Move up',
  moveDown: 'Move down',

  // Messages
  attachmentAdded: 'Attachment added',
  attachmentRemoved: 'Attachment removed',
  attachments: 'Attachments',

  // Specific types
  startPhotos: 'Start Photos',
  returnPhotos: 'Return Photos',

  // Operations feedback
  fetchError: 'Failed to load attachments',
  deleteSuccess: 'Attachment deleted successfully',
  deleteError: 'Failed to delete attachment',
  orderUpdateSuccess: 'Attachment order updated',
  orderUpdateError: 'Failed to update attachment order',
  confirmDelete: 'Are you sure you want to delete this attachment?',

  // AI Edit
  aiEditPrompt: 'Describe how you want to edit this image:',
  aiEditPlaceholder: 'e.g., "Change the background to blue", "Add a shadow", "Make it brighter"',
  aiEditConfirm: 'Edit Image',
  aiEditCancel: 'Cancel',
  aiEditSuccess: 'Image edited successfully',
  aiEditError: 'Failed to edit image',
  aiEditInProgress: 'Editing image with AI...',
  replaceOriginal: 'Replace original image',
  createNewCopy: 'Create new edited copy',

  // Image cropping
  crop: {
    title: 'Crop Image',
    apply: 'Apply Crop',
    reset: 'Reset',
    zoom: 'Zoom',
    rotation: 'Rotation',
    aspectRatio: {
      label: 'Aspect Ratio',
      square: 'Square (1:1)',
      landscape: 'Landscape (4:3)',
      portrait: 'Portrait (3:4)',
      wide: 'Wide (16:9)'
    },
    success: 'Image cropped successfully',
    error: 'Failed to crop image',
    inProgress: 'Cropping image...'
  },
};
